import { UserRole } from '@lombok/shared';

/** Roles shown the "Nuevo cliente" action (the API accepts the same ones; a rep's account is assigned to them). */
const CREATOR_ROLES: readonly UserRole[] = [UserRole.SUPER_ADMIN, UserRole.ADMIN, UserRole.SALES_REP];

export function canCreateCustomer(role: UserRole | undefined): boolean {
  return role !== undefined && CREATOR_ROLES.includes(role);
}
